<!--
 * @Author: litianci
 * @Date: 2022-04-25 17:43:03
 * @LastEditTime: 2022-10-25 14:39:57
-->
<template>
  <div class="index" :style="getIndexStyle()">
    <div class="header">
      <img :src="pageDetail.headPicUrl" @click="openLink(pageDetail)">
    </div>
    <div v-for="(item,index) in pageDetail.moduleList" :key="index">
      <component
        :is="item.type"
        :obj="item"
        :detail='detail'
        @on-click='onClick'
        @open-link='openLink'
        @startCallback='startCallback'></component>
    </div>

    <div class="rulesBtn" v-if="pageDetail.rulesButtonShow == '1'">
      <img @click="rulesClick" :src="pageDetail.rulesButtonImgUrl">
    </div>
    <van-popup v-model:show="showPopup" class="rules-class" round closeable>
      <div v-html="pageDetail.rulesContent"></div>
    </van-popup>

    <van-dialog
      v-model:show="showyz"
      title="请输入验证码"
      show-cancel-button
      @confirm="confirm"
    >
      <Field v-model="yzmValue" label="验证码" placeholder="请输入验证码" />
      <img class="yzmPic" :src="'data:image/gif;base64,' + img" />
    </van-dialog>

    <!-- <Popup v-model:show="show" :close-on-click-overlay="false">
    </Popup> -->
  </div>
</template>
<script>
import { watch, inject, onActivated,ref, reactive, toRefs, } from 'vue';
import { Swipe, SwipeItem, Empty,Toast ,Dialog,Field,Popup} from 'vant';
import { useRouter } from 'vue-router';
import http from '@/api/http';
import { setStyles,showNotify,formatDate2} from '@/utils';
export default {
  components: { Swipe, SwipeItem, Empty,Toast,Field,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
  },
  name: 'index',
  setup (props, { emit }) {
    const { height, width } = inject('windowSize');
    const router = useRouter();
    const pageDetail = ref({})
    const detail  = ref({
      mobileNumber:"",
      luckyDrawNum:0,
      startTime:"",
      endTime:"",
      nowDate:formatDate2(new Date()),
      status:"",
      pageId:"",
      origin:""
    })
    const showyz = ref(false)
    const showPopup = ref(false)
    const yanzObj = reactive({
      showyz:false,
      yzmValue:"",
      img:"",
      uuid:""
    })
    function getIndexStyle () {
      return {
        'min-height': height.value + 'px',
        'background-color':pageDetail.value.bgdColor,
        'padding-bottom':'10px'
      }
    }
    function getPage() {
      // let locationHref = 'https://mini.jieyou.pro/h5outPut/#/index?pageId=78&origin=1'
      // let locationHref = 'https://mini.jieyou.pro/h5outPut/#/index?pageId=91&origin=1'
      let locationHref = window.location.href
      let params = locationHref.split("?")[1]
      let paramsList = params.split("&")
      let pageId
      for(let i=0;i<paramsList.length;i++){
        if(paramsList[i].includes("pageId")){
          pageId = paramsList[i].slice(7,paramsList[i].length)
          detail.value.pageId = paramsList[i].slice(7,paramsList[i].length)
        }
        if(paramsList[i].includes("origin")){
          detail.value.origin = paramsList[i].slice(7,paramsList[i].length)
        }
      }
      http.get("/api/page/getResult",{
        pageId:pageId
      }).then(({data})=>{
        pageDetail.value = data
        detail.value.startTime = data.startTime
        detail.value.endTime = data.endTime
        detail.value.status = data.status
        document.title = data.name
        getIndexStyle()
      })
    }

    function onClick(e) {
      if(detail.value.status == '1'){
        if(detail.value.nowDate < detail.value.startTime){
          showNotify('warning','活动尚未开始')
        }else if(detail.value.nowDate > detail.value.endTime){
          showNotify('warning','活动已结束')
        }else{
          let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
          if(reg.test(detail.value.mobileNumber)){
            yanzObj.showyz = true
            http.get("/captchaImage").then(data=>{
              yanzObj.img = data.img
              yanzObj.uuid = data.uuid

              http.get('/api/order/getTimes?pageId='+pageDetail.value.id+"&phone=" + detail.value.mobileNumber).then(data=>{
                detail.value.luckyDrawNum = data.data
              })
            })
          }else{
            Toast('输入的手机号码有误，请重新输入')
          }
        }
      }else{
        Toast('活动已下架')
      }
    }

    function confirm() {
      http.post("/api/order/coupon?pageId="+detail.value.pageId+"&phone="+detail.value.mobileNumber+"&code="+yanzObj.yzmValue+'&uuid='+yanzObj.uuid+"&origin="+detail.value.origin).then((data)=>{
        if(data.code == 200){
          Toast(data.msg)
        }else{
          if(data.msg.indexOf('注册') != -1){
            Toast(data.msg)
            phoneState()
          }else{
            Toast(data.msg)
          }
        }
      }).catch((error)=>{})
    }
    function openLink(item) {
      if(item.headPicJumpType == "0" || item.type == "0"){
        return
      }
      router.push({
        name:"jumpMidPage",
        query:{
          params:encodeURIComponent(JSON.stringify(item))
        }
      })
    }


    function startCallback(e,obj) {
      if(detail.value.nowDate < detail.value.startTime){
        showNotify('warning','活动尚未开始')
        return
      }else if(detail.value.nowDate > detail.value.endTime){
        showNotify('warning','活动已结束')
        return
      }
      if(detail.value.luckyDrawNum){
        http.get("/api/order/getWinning?pageId=" + pageDetail.value.id +"&phone=" + detail.value.mobileNumber).then((data)=>{
          // console.log(data,'data');
          // 调用抽奖组件的play方法开始游戏
          e.play()
          console.log('调用pay开始游戏');
          detail.value.luckyDrawNum --
          setTimeout(()=>{
            // 获取商品索引
            let backIndex = obj.pageRoundaboutList.findIndex(v=>{
              return v.id == data.data
            })
            // 调用stop停止旋转并传递中奖索引
            e.stop(backIndex)
            let prize = obj.pageRoundaboutList.find(v=>{
              if(v.id == data.data){
                return v
              }
            })

            setTimeout(()=>{
              if(prize.type == '1'){
                Dialog.confirm({
                  title: '恭喜您，中奖啦',
                  message:prize.name,
                  confirmButtonText:"去使用"
                })
                  .then(() => {
                    router.push({
                      name:"jumpMidPage"
                    })
                  })
                  .catch(() => {});
              }else{
                Toast(prize.name)
              }
            },3000)

          },5000)

        }).catch((err)=>{
          console.log(err,'err');
          if(err.indexOf('注册') != -1){
            console.log('未注册1');
            // phoneState()
          }
        })
      }else{
        showNotify('danger','暂无抽奖次数')
      }
    }

    function rulesClick() {
      showPopup.value = true
    }

    // 未注册下载
    function phoneState() {
      setInterval(()=>{
        let isWeixin = navigator.appVersion.indexOf("MicroMessenger") > -1;
        let sys = navigator.userAgent;
        if(isWeixin){
          if (sys.indexOf("Android") > -1 || sys.indexOf("Linux") > -1) {
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.unionpay&android_schema=upwallet";
          }
          if (sys.indexOf("iPhone") > -1) {
            window.location.href = "https://usl.95516.com/rn/";
          }
        }else{
          if (sys.indexOf("Android") > -1 || sys.indexOf("Linux") > -1) {
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.unionpay&android_schema=upwallet";
          }
          if (sys.indexOf("iPhone") > -1) {
            Toast("正在下载，稍后请安装！");
            window.location.href =
              "https://apps.apple.com/cn/app/%E4%BA%91%E9%97%AA%E4%BB%98-%E9%93%B6%E8%A1%8C%E4%B8%9A%E7%BB%9F%E4%B8%80%E7%A7%BB%E5%8A%A8%E6%94%AF%E4%BB%98app/id600273928";
          }
        }
      },2000)
    }


    watch([height, width], () => {
      getIndexStyle();
    });
    watch(()=>yanzObj.showyz,()=>{
      if(yanzObj.showyz == false){
        yanzObj.yzmValue = ""
      }
    })

    onActivated(() => { });
    getPage()
    return {
      detail,
      getIndexStyle,
      setStyles,
      pageDetail,
      onClick,
      openLink,
      startCallback,
      confirm,
      showyz,
      rulesClick,
      showPopup,
      ...toRefs(yanzObj),
      phoneState
    }
  },

}
</script>
<style scoped>
.header{
  width: 100%;
  font-size: 0;
}
.header>img{
  width: 100%;
}
:deep(.van-dialog__content){
  display: flex;
}
:deep(.van-field__label){
  width: 2.4rem;
}
.yzmPic{
  width: 35%;
  margin-right: .5rem;
}
.rulesBtn{
  width: 2.6rem;
  height: 2.6rem;
  position: fixed;
  top: 35%;
  right: 0;
}
.rulesBtn > img{
  width: 100%;
}
:deep(.rules-class){
  width: 80%;
  min-height: 14rem;
  max-height: 75%;
  padding: 1rem 0.8rem 0.53rem;
}
:deep(.rules-class p){
  margin: .3rem 0;
}
</style>
